import { render, staticRenderFns } from "./pendingLicensesComp.vue?vue&type=template&id=1ba0446b"
import script from "./pendingLicensesComp.vue?vue&type=script&lang=js"
export * from "./pendingLicensesComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports